import { createBrowserHistory } from 'history';
import * as React from 'react';
import { AppContext, AppContextType } from '../../AppContextType';
import { ScrollToHelper } from '../../Helpers/ScrollToHelper';
import { Direction, sortByProperty } from '../../Helpers/SortHelper';
import { JobCenterModelInterface } from '../../Model/JobCenterModelInterface';
import { JobVacancy } from '../../Model/JobVacancy';
import { UriBuilder } from '../../Service/UriBuilder';
import { StaticSettings } from '../../StaticSettings';
import { Type } from '../../Type';
import { ListProps } from '../ListProps';
import { PageBrowser } from '../Pagination/PageBrowser';
import { PageBrowserLabels } from '../Pagination/PageBrowserLabels';
import { Pagination } from '../Pagination/Pagination';
import { PaginationList } from '../Pagination/PaginationList';
import { GridItem } from './GridItem';

export class Grid extends React.Component<ListProps<JobVacancy>> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;

    public render() {
        const filteredModels = this.props.filteredModels;
        const sortProperty = StaticSettings.ui.list.jobVacancySortBy;
        if (sortProperty !== undefined) {
            return this.renderGrid(sortByProperty(filteredModels, sortProperty, Direction.Desc));
        } else {
            return this.renderGrid(filteredModels);
        }
    }

    private renderGrid(models: JobVacancy[]) {
        const selectedJobVacancies = this.props.selectedJobVacancies;
        const isSelected = (m: JobCenterModelInterface) => {
            return selectedJobVacancies.contains(m);
        };

        const initialPage = this.props.requestedPageNumber || StaticSettings.ui.pagination.initialPage;

        const handleChangePage = (pageNumber: number, itemsOnPage: JobVacancy[]) => {
            console.debug(
                '[JobVacancyList] Show page number ' + pageNumber,
                itemsOnPage
            );
            const uriBuilder = new UriBuilder();
            const paginationUri = uriBuilder.paginationUriForType(Type.JobVacancy, pageNumber);
            createBrowserHistory().push(paginationUri);
            ScrollToHelper.scrollToAnchor();
        };
        const translate = this.context.i18n.translate;
        const labels: PageBrowserLabels = {
            first: translate('pagination.first'),
            last: translate('pagination.last'),
            previous: translate('pagination.previous'),
            next: translate('pagination.next'),
        };

        return <div className="container">
            <Pagination {...StaticSettings.ui.pagination}
                        labels={labels}
                        items={models}
                        onChangePage={handleChangePage}
                        initialPage={initialPage}>
                <div className="row">
                    <PaginationList>
                        {(model: JobVacancy) =>
                            <GridItem key={model.referenceId} model={model} selected={isSelected(model)}/>
                        }
                    </PaginationList>
                </div>
                <div className="row">
                    <PageBrowser/>
                </div>
            </Pagination>
        </div>;
    }
}
